import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { DtoRegistryOfficeTypeCreate, ProductItem, RegistryOfficeType } from 'src/app/api/models';
import { RegistryOfficesService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-office-type',
  templateUrl: './modal-office-type.component.html',
  styleUrls: ['./modal-office-type.component.scss'],
})
export class ModalOfficeTypeComponent {
  question_title: string;

  frm = new FormGroup({
    name: new FormControl('', [Validators.required]),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private officeService: RegistryOfficesService,
    private confirmationService: ConfirmationService
  ) {
    this.question_title = config.data!.question_title;
    if (config.data!.initial_value) {
      this.frm.get('name')!.setValue(config.data!.initial_value.name);
    }
  }

  ngOnInit() {}

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ value: { name: this.frm.get('name')!.value } });
  }
}
